import { AuthenticationService } from 'app/components/sessions/login/auth.service';
import { Component } from '@angular/core';
import { MenuService } from '@core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user',
  template: `
    <a mat-button href="javascript:void(0)" class="user-details"
      ><!--[matMenuTriggerFor]="menu"-->
      Welcome Himanshu Jain
      <img
        class="matero-user-avatar r-full align-middle"
        src="assets/images/user-96x96.jpg"
        width="28"
        alt="avatar"
      />
      <!--<mat-icon>keyboard_arrow_down</mat-icon>-->
    </a>

    <mat-menu #menu="matMenu">
      <a mat-menu-item>
        <mat-icon log>exit_to_app</mat-icon>
        <span (click)="logOut()">Logout</span>
      </a>
    </mat-menu>
  `,
})
export class UserComponent {
  constructor(private router: Router, private menuService: MenuService) {}

  logOut() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
